import { useEffect, useState } from "react";
import { Avatar, Box, Tab, Tabs, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Breadcrumb from "../../../../components/breadcrumb/breadcrumb";
import UserDetailsTab from "./user-details-tab/user-details-tab";
import RolesPermissionsTab from "./roles-permissions-tab/roles-permissions-tab";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import ConstructionOutlinedIcon from "@mui/icons-material/ConstructionOutlined";
import { useDispatch, useSelector } from "react-redux";
import { getUserDetailsRequest } from "../../../../redux/users/slice";
import Loading from "../../../../components/loading/loading";
import { userType } from "../../../../utils/Constant";
import Certifications from "./certifications/certifications";
import BlackOutCalendar from "./blackout-calendar/blackout-calendar";
import ContactSpectrum from "../../../../components/contact-spectrum/constact-spectrum";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function TabLabel(data: any) {
  return (
    <>
      {data?.label}
      {data?.showWarning && (
        <InfoOutlinedIcon className="tab-label-warning-icon" />
      )}
    </>
  );
}

export default function UserDetails() {
  const { state } = useLocation();
  const { pathname } = useLocation();
  const [value, setValue] = useState(0);
  const [isMyOrganisation, setIsMyOrganisation] = useState(false);
  const dispatch = useDispatch();

  const { userDetails, currentUser } = useSelector((state: any) => state.user.user);
  const { loading } = useSelector((state: any) => state.user);

  useEffect(() => {
    dispatch(getUserDetailsRequest({ id: state?.id }));
  }, [state, dispatch]);

  useEffect(() => {
    if (pathname?.includes("my-organization")) {
      setIsMyOrganisation(true);
    } else {
      setIsMyOrganisation(false);
    }
  }, [pathname]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      {currentUser?.userType !== userType.client && <ContactSpectrum />}
      <Box mt={currentUser?.userType === userType.client ? 2 : 0}>
        <Breadcrumb />
      </Box>
      <Box className="user-info-layout">
        <Avatar className="user-avatar" alt="Avatar" variant="circular">
          <PersonIcon />
        </Avatar>
        <Box className="margin-left">
          <Typography variant="h4">
            {userDetails?.firstName} {userDetails?.lastName}
          </Typography>
          <Box className="user-details-content">
            {userDetails?.userType === userType.client && (
              <Box className="user-location-content">
                <BusinessOutlinedIcon className="user-location-icon" />
                <Typography className="user-location-txt">
                  {userDetails?.clientName}
                </Typography>
              </Box>
            )}
            {userDetails?.userType === userType.inspector && (
              <Box className="user-location-content">
                <ConstructionOutlinedIcon className="user-location-icon" />
                <Typography className="user-location-txt">
                  {userDetails?.inspectorFirmName}
                </Typography>
              </Box>
            )}
            {userDetails?.userType === userType.tenant && (
              <Box className="user-location-content">
                <img
                  src={require("../../../../assets/Vision_Stone.svg").default}
                  alt="Internal User"
                />
                <Typography className="user-location-txt">Spectrum</Typography>
              </Box>
            )}
          </Box>
        </Box>
      </Box>

      <Box className="tab-header">
        {(userDetails?.userType === userType?.tenant ||
          userDetails?.userType === userType?.client) && (
          <>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="user details tabs"
              variant="scrollable"
              scrollButtons={false}
            >
              <Tab
                className="tab-label"
                label={<TabLabel label="Details" showWarning={false} />}
              />
              <Tab
                className="tab-label"
                label={
                  <TabLabel label="Roles & Permissions" showWarning={false} />
                }
              />
            </Tabs>
          </>
        )}
        {userDetails?.userType === userType?.inspector && (
          <>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="user details tabs"
              variant="scrollable"
              scrollButtons={false}
            >
              <Tab
                className="tab-label"
                label={<TabLabel label="Details" showWarning={false} />}
              />
              <Tab
                className="tab-label"
                label={
                  <TabLabel label="Roles & Permissions" showWarning={false} />
                }
              />
              <Tab
                className="tab-label"
                label={<TabLabel label="Certifications" showWarning={false} />}
              />
              <Tab
                className="tab-label"
                label={
                  <TabLabel label="Blackout Calendar" showWarning={false} />
                }
              />
            </Tabs>
          </>
        )}
      </Box>
      <CustomTabPanel value={value} index={0}>
        <UserDetailsTab
          data={userDetails}
          isMyOrganisation={isMyOrganisation}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <RolesPermissionsTab
          data={userDetails}
          isMyOrganisation={isMyOrganisation}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <Certifications
          data={userDetails}
          isMyOrganisation={isMyOrganisation}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <BlackOutCalendar data={userDetails} />
      </CustomTabPanel>

      {loading && <Loading />}
    </>
  );
}
